import React, { useEffect, useRef } from "react";

// Subtle gold sparkle cursor trail — desktop only.
const CustomCursor = () => {
  const particlesRef = useRef([]);
  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const onMove = (e) => {
      if (Math.random() > 0.5) return;
      const dot = document.createElement("span");
      dot.className = "knight-spark";
      dot.style.left = `${e.clientX}px`;
      dot.style.top = `${e.clientY}px`;
      document.body.appendChild(dot);
      particlesRef.current.push(dot);
      setTimeout(() => { dot.remove(); }, 700);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);
  return null;
};
export default CustomCursor;
